import styled from 'styled-components';

const FeedbackQuestionViewWrapper = styled.div`
  .likert-scale-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .number-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-top: 16px;
  }

  .segment {
    text-align: center;
    position: relative;
  }

  .scale-line {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
    height: 2px;
    background-color: black;
    margin-top: 10px;
  }

  .marker {
    position: relative;
    top: 50%;
    input {
      background-color: rgb(251, 251, 251);
    }
    .radio-children {
      display: none;
    }
  }

  .segment-first {
    display: flex;
    justify-content: flex-start;
  }

  .segment-last {
    display: flex;
    justify-content: flex-end;
  }

  .section-text {
    text-align: center;
  }
`;

export default FeedbackQuestionViewWrapper;
